// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_fy-a";
export var fulfillmentFormRail = "_fy-9";
export var headerTitleRow = "_fy-c";
export var orderDetailsWrapper = "_fy-7";
export var orderLinkTrigger = "_fy-2";
export var paymentInformationGrid = "_fy-h";
export var paymentSummaryColumn = "_fy-i";
export var shipmentContainer = "_fy-b";
export var shipmentDetailsMainPane = "_fy-8";
export var shipmentNavigationCard = "_fy-5";
export var shipmentNavigationRail = "_fy-3";
export var shipmentNavigationRailHeader = "_fy-4";
export var shipmentSummaryFact = "_fy-e";
export var shipmentSummaryGrid = "_fy-d";
export var shipmentSummaryMetadataRow = "_fy-f";
export var shipmentSummaryTags = "_fy-g";
export var shipmentWorkspace = "_fy-0";
export var shipmentWorkspaceContent = "_fy-6";
export var shipmentWorkspaceHeader = "_fy-1";